import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  Row,
  Table,
  Col,
  Form,
  FormGroup,
  Label,
  Input,
  Spinner,
  Button,
} from "reactstrap";
import "../../styles/businessBackofficeStyles.scss";
import "../../styles/Integrations.css";
import "../../../Assets/img/icons/b2b/integrationLogos/bambooHRLogo.png";
import gmailLogo from "../../../Assets/img/icons/b2b/integrationLogos/gmailLogo.png";
import "../../../Assets/img/icons/b2b/integrationLogos/outlookLogo.png";
import {
  deleteGmailConnection,
  getGmailConnections,
  getWhatsappAccount,
  createWhatsappAccount,
  updateWhatsappAccount,
  deleteWhatsappAccount
} from "../../../ApiCalls/mantisBusiness";
import {backUrl} from "../../../utils/backURL";
import {selectAuthState} from "../../../store/selectors/authSelectors";

function BusinessIntegrations(props) {
  const [loading, setLoading] = useState(false);
  const [gmailConnections, setGmailConnections] = useState([]);
  const [deletingGmailConnection, setDeletingGmailConnection] = useState(false);
  const [whatsappAccount, setWhatsappAccount] = useState(null);
  const [loadingWhatsapp, setLoadingWhatsapp] = useState(false);
  const [showWhatsappModal, setShowWhatsappModal] = useState(false);
  const [whatsappFormData, setWhatsappFormData] = useState({
    accountName: "",
    phoneId: "",
    apiKey: "",
    isActive: true
  });

  // Determinar si está en modo embedded
  const {embedded = false} = props;

  useEffect(() => {
    getData();
    getWhatsappData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getData = async () => {
    setLoading(true);
    const response = await getGmailConnections(
      props.token,
      props.mantisBusiness._id
    );
    console.log(response);
    if (response.success) {
      setGmailConnections(response.connections);
    }
    setLoading(false);
  };

  const getWhatsappData = async () => {
    setLoadingWhatsapp(true);
    const response = await getWhatsappAccount(
      props.token,
      props.mantisBusiness._id
    );
    if (response.success) {
      setWhatsappAccount(response.account);
    }
    setLoadingWhatsapp(false);
  };

  const handleDeleteGmailConnection = async (connectionId) => {
    setDeletingGmailConnection(true);
    const res = await deleteGmailConnection(
      props.token,
      connectionId,
      props.mantisBusiness._id
    );
    if (res.success) {
      getData();
    } else {
      alert("Error al eliminar la conexión");
    }
    setDeletingGmailConnection(false);
  };

  const handleOpenWhatsappModal = () => {
    if (whatsappAccount) {
      setWhatsappFormData({
        accountName: whatsappAccount.accountName || "",
        phoneId: whatsappAccount.phoneId || "",
        apiKey: "", // Don't show existing API key
        isActive:
          whatsappAccount.isActive !== undefined
            ? whatsappAccount.isActive
            : true
      });
    } else {
      setWhatsappFormData({
        accountName: "",
        phoneId: "",
        apiKey: "",
        isActive: true
      });
    }
    setShowWhatsappModal(true);
  };

  const handleCloseWhatsappModal = () => {
    setShowWhatsappModal(false);
    setWhatsappFormData({
      accountName: "",
      phoneId: "",
      apiKey: "",
      isActive: true
    });
  };

  const handleSaveWhatsappAccount = async () => {
    if (
      !whatsappFormData.accountName ||
      !whatsappFormData.phoneId ||
      (!whatsappAccount && !whatsappFormData.apiKey)
    ) {
      alert("Por favor complete todos los campos requeridos");
      return;
    }

    setLoadingWhatsapp(true);
    try {
      let res;
      if (whatsappAccount) {
        // Update existing account
        res = await updateWhatsappAccount(
          props.token,
          whatsappAccount._id,
          whatsappFormData
        );
      } else {
        // Create new account
        res = await createWhatsappAccount(
          props.token,
          props.mantisBusiness._id,
          whatsappFormData
        );
      }

      if (res.success) {
        getWhatsappData();
        handleCloseWhatsappModal();
      } else {
        alert(res.error || "Error al guardar la cuenta de WhatsApp");
      }
    } catch (error) {
      console.error("Error saving WhatsApp account:", error);
      alert("Error al guardar la cuenta de WhatsApp");
    } finally {
      setLoadingWhatsapp(false);
    }
  };

  const handleDeleteWhatsappAccount = async () => {
    if (!whatsappAccount) return;

    if (
      !window.confirm(
        "¿Está seguro de que desea eliminar esta cuenta de WhatsApp?"
      )
    ) {
      return;
    }

    setLoadingWhatsapp(true);
    try {
      const res = await deleteWhatsappAccount(props.token, whatsappAccount._id);
      if (res.success) {
        getWhatsappData();
      } else {
        alert("Error al eliminar la cuenta de WhatsApp");
      }
    } catch (error) {
      console.error("Error deleting WhatsApp account:", error);
      alert("Error al eliminar la cuenta de WhatsApp");
    } finally {
      setLoadingWhatsapp(false);
    }
  };

  return (
    <div className={embedded ? "p-6" : ""}>
      {!embedded && (
        <>
          <Row>
            <Col xs={11} className="mx-auto">
              <Row>
                <Col xs={6}>
                  <h1 className="business-viewpanel-title">Fuentes de datos</h1>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col xs={11} className="mx-auto">
              <h2 className="business-viewpanel-subtitle">
                Conecta tus fuentes de información
              </h2>
            </Col>
          </Row>
        </>
      )}
      <Row>
        <Col xs={embedded ? 12 : 11} className={embedded ? "" : "mx-auto"}>
          {embedded && (
            <div className="mb-6">
              <h3 className="text-lg font-semibold text-slate-800 dark:text-slate-200 mb-2">
                Conectar Fuentes de Información
              </h3>
              <p className="text-slate-600 dark:text-slate-400 mb-4">
                Conecte sus cuentas de Gmail para integrar sus comunicaciones
                con el sistema
              </p>
            </div>
          )}
          <Row>
            {/* <Col xs={2}>
            <div className="business-integrations-integration-container">
              <img
                src={bambooLogo}
                alt="bambooHR"
                className="business-integrations-integration-logo"
              />
              <h3 className="business-integrations-integration-title">
                Bamboo HR
              </h3>
            </div>
          </Col> */}
            <Col xs={embedded ? 6 : 2}>
              <div
                className="business-integrations-integration-container"
                onClick={() => {
                  window.open(
                    `${backUrl}/googleOAuth/auth?mantisBusinessId=${props.mantisBusiness._id}`
                  );
                }}
              >
                <img
                  src={gmailLogo}
                  alt="Gmail"
                  className="business-integrations-integration-logo"
                />
                <h3 className="business-integrations-integration-title">
                  Gmail
                </h3>
              </div>
            </Col>
            <Col xs={embedded ? 6 : 2}>
              <div
                className="business-integrations-integration-container"
                onClick={handleOpenWhatsappModal}
                style={{cursor: "pointer"}}
              >
                <div
                  style={{
                    width: "64px",
                    height: "64px",
                    borderRadius: "12px",
                    background:
                      "linear-gradient(135deg, #25D366 0%, #128C7E 100%)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "32px",
                    margin: "0 auto 8px"
                  }}
                >
                  📱
                </div>
                <h3 className="business-integrations-integration-title">
                  WhatsApp
                </h3>
              </div>
            </Col>
            {/* <Col xs={2}>
            <div className="business-integrations-integration-container">
              <img
                src={outlookLogo}
                alt="Outlook"
                className="business-integrations-integration-logo"
              />
              <h3 className="business-integrations-integration-title">Outlook</h3>
            </div>
          </Col> */}
          </Row>
        </Col>
      </Row>
      <Row className="mt-4">
        <Col xs={embedded ? 12 : 11} className={embedded ? "" : "mx-auto"}>
          {loading ? (
            <div className="spinner-container">
              <Spinner className="main-spinner" />
            </div>
          ) : (
            <Col xs={12}>
              <h3
                className={
                  embedded
                    ? "text-lg font-semibold text-slate-800 dark:text-slate-200 mb-4"
                    : "integration-section-title"
                }
              >
                Cuentas conectadas
              </h3>
              {gmailConnections.length > 0 ? (
                <Table className="integration-table" responsive>
                  <thead>
                    <tr className="integration-table-header">
                      <th></th>
                      <th>Nombre</th>
                      <th>Estado</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {gmailConnections.map((connection) => {
                      let expiryDate = new Date(connection.expiryDate);
                      expiryDate.setDate(expiryDate.getDate() + 7);
                      let isExpired = new Date() >= expiryDate;
                      return (
                        <tr
                          key={connection._id}
                          className="integration-table-row"
                        >
                          <td>
                            <img
                              src={gmailLogo}
                              alt="Gmail"
                              className="integration-logo-small"
                            />
                          </td>
                          <td>{connection.email}</td>
                          <td>
                            <span
                              className={`connection-status ${
                                isExpired ? "expired" : "active"
                              }`}
                              onClick={() => {
                                if (isExpired) {
                                  window.open(
                                    `${backUrl}/googleOAuth/auth?mantisBusinessId=${props.mantisBusiness._id}`
                                  );
                                }
                              }}
                            >
                              {isExpired ? "Expirado" : "Activo"}
                            </span>
                          </td>
                          <td>
                            <button
                              className="delete-connection-button"
                              onClick={() =>
                                handleDeleteGmailConnection(connection._id)
                              }
                              disabled={deletingGmailConnection}
                            >
                              {deletingGmailConnection ? (
                                <div className="button-spinner-container">
                                  <Spinner
                                    size="sm"
                                    className="button-spinner"
                                  />
                                </div>
                              ) : (
                                <i className="fas fa-trash-alt"></i>
                              )}
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              ) : (
                <div className="no-connections-message">
                  <p>No hay cuentas conectadas</p>
                </div>
              )}
            </Col>
          )}
        </Col>
      </Row>

      {/* WhatsApp Account Section */}
      <Row className="mt-4">
        <Col xs={embedded ? 12 : 11} className={embedded ? "" : "mx-auto"}>
          <h3
            className={
              embedded
                ? "text-lg font-semibold text-slate-800 dark:text-slate-200 mb-4"
                : "integration-section-title"
            }
          >
            Cuenta de WhatsApp
          </h3>
          {loadingWhatsapp ? (
            <div className="spinner-container">
              <Spinner className="main-spinner" />
            </div>
          ) : whatsappAccount ? (
            <Table className="integration-table" responsive>
              <thead>
                <tr className="integration-table-header">
                  <th></th>
                  <th>Nombre</th>
                  <th>Phone ID</th>
                  <th>Estado</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr className="integration-table-row">
                  <td>
                    <div
                      style={{
                        width: "32px",
                        height: "32px",
                        borderRadius: "8px",
                        background:
                          "linear-gradient(135deg, #25D366 0%, #128C7E 100%)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "16px"
                      }}
                    >
                      📱
                    </div>
                  </td>
                  <td>{whatsappAccount.accountName}</td>
                  <td>{whatsappAccount.phoneId}</td>
                  <td>
                    <span
                      className={`connection-status ${
                        whatsappAccount.isActive ? "active" : "expired"
                      }`}
                    >
                      {whatsappAccount.isActive ? "Activo" : "Inactivo"}
                    </span>
                  </td>
                  <td>
                    <div style={{display: "flex", gap: "8px"}}>
                      <button
                        className="delete-connection-button"
                        onClick={handleOpenWhatsappModal}
                        style={{
                          background: "#007bff",
                          color: "white",
                          border: "none"
                        }}
                      >
                        <i className="fas fa-edit"></i>
                      </button>
                      <button
                        className="delete-connection-button"
                        onClick={handleDeleteWhatsappAccount}
                        disabled={loadingWhatsapp}
                      >
                        {loadingWhatsapp ? (
                          <div className="button-spinner-container">
                            <Spinner size="sm" className="button-spinner" />
                          </div>
                        ) : (
                          <i className="fas fa-trash-alt"></i>
                        )}
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </Table>
          ) : (
            <div className="no-connections-message">
              <p>No hay cuenta de WhatsApp configurada</p>
              <Button
                color="primary"
                onClick={handleOpenWhatsappModal}
                className="mt-2"
              >
                Configurar cuenta de WhatsApp
              </Button>
            </div>
          )}
        </Col>
      </Row>

      {/* WhatsApp Account Modal */}
      {showWhatsappModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000
          }}
          onClick={handleCloseWhatsappModal}
        >
          <div
            style={{
              backgroundColor: "white",
              padding: "28px",
              borderRadius: "12px",
              maxWidth: "550px",
              width: "90%",
              maxHeight: "90vh",
              overflow: "auto",
              boxShadow: "0 10px 40px rgba(0, 0, 0, 0.15)"
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "24px",
                paddingBottom: "16px",
                borderBottom: "1px solid #e5e7eb"
              }}
            >
              <h3
                style={{
                  margin: 0,
                  fontSize: "20px",
                  fontWeight: "600",
                  color: "#1f2937"
                }}
              >
                {whatsappAccount
                  ? "Editar cuenta de WhatsApp"
                  : "Configurar cuenta de WhatsApp"}
              </h3>
              <button
                onClick={handleCloseWhatsappModal}
                style={{
                  background: "none",
                  border: "none",
                  fontSize: "28px",
                  cursor: "pointer",
                  color: "#6b7280",
                  padding: "0",
                  width: "32px",
                  height: "32px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: "4px"
                }}
                onMouseEnter={(e) =>
                  (e.target.style.backgroundColor = "#f3f4f6")
                }
                onMouseLeave={(e) =>
                  (e.target.style.backgroundColor = "transparent")
                }
              >
                ×
              </button>
            </div>
            <Form>
              <FormGroup className="mb-3">
                <Label
                  for="accountName"
                  style={{
                    fontWeight: "500",
                    marginBottom: "6px",
                    display: "block",
                    color: "#374151"
                  }}
                >
                  Nombre de la cuenta <span style={{color: "#ef4444"}}>*</span>
                </Label>
                <Input
                  id="accountName"
                  type="text"
                  value={whatsappFormData.accountName}
                  onChange={(e) =>
                    setWhatsappFormData({
                      ...whatsappFormData,
                      accountName: e.target.value
                    })
                  }
                  placeholder="Ej: Cuenta Principal"
                  style={{marginBottom: "4px"}}
                />
                <small
                  className="text-muted"
                  style={{fontSize: "13px", color: "#6b7280"}}
                >
                  Un nombre descriptivo para identificar esta cuenta
                </small>
              </FormGroup>
              <FormGroup className="mb-3">
                <Label
                  for="phoneId"
                  style={{
                    fontWeight: "500",
                    marginBottom: "6px",
                    display: "block",
                    color: "#374151"
                  }}
                >
                  Phone ID <span style={{color: "#ef4444"}}>*</span>
                </Label>
                <Input
                  id="phoneId"
                  type="text"
                  value={whatsappFormData.phoneId}
                  onChange={(e) =>
                    setWhatsappFormData({
                      ...whatsappFormData,
                      phoneId: e.target.value
                    })
                  }
                  placeholder="Ej: 123456789012345"
                  style={{marginBottom: "4px"}}
                />
                <small
                  className="text-muted"
                  style={{fontSize: "13px", color: "#6b7280"}}
                >
                  El ID del número de teléfono de WhatsApp Business
                </small>
              </FormGroup>
              <FormGroup className="mb-3">
                <Label
                  for="apiKey"
                  style={{
                    fontWeight: "500",
                    marginBottom: "6px",
                    display: "block",
                    color: "#374151"
                  }}
                >
                  API Key{" "}
                  {!whatsappAccount && (
                    <span style={{color: "#ef4444"}}>*</span>
                  )}
                </Label>
                <Input
                  id="apiKey"
                  type="password"
                  value={whatsappFormData.apiKey}
                  onChange={(e) =>
                    setWhatsappFormData({
                      ...whatsappFormData,
                      apiKey: e.target.value
                    })
                  }
                  placeholder={
                    whatsappAccount
                      ? "Dejar vacío para mantener el actual"
                      : "Ingrese el API Key de WhatsApp Business"
                  }
                  style={{marginBottom: "4px"}}
                />
                {whatsappAccount ? (
                  <small
                    className="text-muted"
                    style={{fontSize: "13px", color: "#6b7280"}}
                  >
                    Dejar vacío para mantener el API Key actual
                  </small>
                ) : (
                  <small
                    className="text-muted"
                    style={{fontSize: "13px", color: "#6b7280"}}
                  >
                    Token de acceso de WhatsApp Business API
                  </small>
                )}
              </FormGroup>
              <FormGroup check className="mt-3 mb-4">
                <Label
                  check
                  style={{
                    fontWeight: "500",
                    color: "#374151",
                    cursor: "pointer"
                  }}
                >
                  <Input
                    type="checkbox"
                    checked={whatsappFormData.isActive}
                    onChange={(e) =>
                      setWhatsappFormData({
                        ...whatsappFormData,
                        isActive: e.target.checked
                      })
                    }
                    style={{marginRight: "8px", cursor: "pointer"}}
                  />
                  Cuenta activa
                </Label>
                <small
                  className="text-muted d-block mt-1"
                  style={{
                    fontSize: "13px",
                    color: "#6b7280",
                    marginLeft: "24px"
                  }}
                >
                  Desactive esta opción para deshabilitar temporalmente la
                  cuenta
                </small>
              </FormGroup>
              <div
                style={{
                  display: "flex",
                  gap: "12px",
                  justifyContent: "flex-end",
                  marginTop: "24px",
                  paddingTop: "20px",
                  borderTop: "1px solid #e5e7eb"
                }}
              >
                <Button color="secondary" onClick={handleCloseWhatsappModal}>
                  Cancelar
                </Button>
                <Button
                  color="primary"
                  onClick={handleSaveWhatsappAccount}
                  disabled={loadingWhatsapp}
                >
                  {loadingWhatsapp ? (
                    <>
                      <Spinner size="sm" className="mr-2" />
                      Guardando...
                    </>
                  ) : (
                    "Guardar"
                  )}
                </Button>
              </div>
            </Form>
          </div>
        </div>
      )}
    </div>
  );
}

export default connect(selectAuthState)(BusinessIntegrations);
